import CreateNewPassword from "./CreateNewPassword";
import ForgotPassword from "./ForgotPassword";


export {
    CreateNewPassword,
    ForgotPassword
}